import * as React from 'react';

import { MouseButtons } from './MouseButtonsEnum';

export const handleClickEvents = (onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void) => {
    return {
        onClick: (e: React.MouseEvent<HTMLAnchorElement>) => onClick(e),
        onMouseDown: (e: React.MouseEvent<HTMLAnchorElement>) => {
            if (e.button === MouseButtons.MiddleButton) {
                onClick(e);
            }
        }
    };
};
